module.exports = __webpack_public_path__ + "static/media/Patroclus.5540dfab.jpg";